import PropTypes from 'prop-types';
import styled from 'styled-components';
import { c as config, m as media, o as orderResolutions } from './styledConfig-9b5d3732.js';

const createMediaQueries = config.resolutions.map(size => {
  let mquery = media[size]`
        max-width: ${config.containerMaxWidth[size]}px;
        padding: 0 1rem;
      `;
  return mquery;
});
const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-ozj74p-0"
})(["width:100%;", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], props => props.backgroundColor && `background-color:${props.backgroundColor};`, props => props.center && `text-align:center;`, props => !props.margin ? `
      margin-left: auto;
      margin-right: auto;
    ` : `
      margin: ${props.margin};
    `, props => !props.type && !props.padding ? `
      padding-right: ${config.paddingDefault}rem;
      padding-left: ${config.paddingDefault}rem;
    ` : `
      padding: ${props.padding};
    `, props => props.flexbox && `display:flex;`, props => props.type === 'fluid' && `
    padding-right: ${config.paddingFluidDefault}rem;
    padding-left: ${config.paddingFluidDefault}rem;
  `, props => props.type === 'full' && `
    padding-right: 0rem;
    padding-left: 0rem;
  `, ({
  borderRadius
}) => borderRadius && `border-radius: ${borderRadius};`, props => !props.type && createMediaQueries, props => {
  let mqGenerated;
  let resolutions = orderResolutions(props);
  if (resolutions.length > 0) {
    mqGenerated = resolutions.map(_dim => {
      if (props[_dim].indexOf(';') > -1) {
        return media[_dim]`${props[_dim]}`;
      }
    });
  }
  return mqGenerated;
});
Container.defaultProps = {
  flexbox: false
};
Container.propTypes = {
  backgroundColor: PropTypes.string,
  type: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  children: PropTypes.node,
  center: PropTypes.bool,
  borderRadius: PropTypes.string,
  flexbox: PropTypes.bool
};

export { Container as default };
